import { Common } from './common';
import { SuccessResponse } from './models/common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async exportedToEhrManually(encounterId: string): Promise<SuccessResponse> {
    const url = this.common.constructPath(`/billing/exportedToEhrManually`);
    return this.common.postJSON(url, { encounterId });
  }

  async exportToEhr(encounterId: string): Promise<SuccessResponse> {
    const url = this.common.constructPath(`/billing/exportToEhr`);
    return this.common.postJSON(url, { encounterId });
  }
}
